import { createSystem, defaultConfig } from "@chakra-ui/react";

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        body: { value: "'Noto Sans JP', sans-serif" },
        heading: { value: "'Noto Sans JP', sans-serif" },
      },
    },
  },
});
